import { Component, inject, signal, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService, Lang } from '../../services/translation.service';

interface LangOption { code: Lang; label: string; flag: string; }

@Component({
  selector: 'app-lang-switcher',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lang-switcher.html',
  styleUrl: './lang-switcher.scss',
})
export class LangSwitcher {
  ts = inject(TranslationService);
  open = signal(false);

  langs: LangOption[] = [
    { code: 'pt', label: 'Português', flag: '🇧🇷' },
    { code: 'en', label: 'English',   flag: '🇺🇸' },
    { code: 'es', label: 'Español',   flag: '🇪🇸' },
    { code: 'zh', label: '中文',       flag: '🇨🇳' },
  ];

  get current() { return this.langs.find(l => l.code === this.ts.lang())!; }

  toggle() { this.open.update(v => !v); }
  select(code: Lang) { this.ts.setLang(code); this.open.set(false); }

  @HostListener('document:click', ['$event'])
  onDocClick(e: Event) {
    const el = e.target as HTMLElement;
    if (!el.closest('app-lang-switcher')) this.open.set(false);
  }
}
